export default __webpack_public_path__ + "static/outechcompanypic-min-76208bc5d7aa5cbfa4c80050b2574f65.png";